import { CustomTableColumn } from "./custom-table-column";

export class ImageTableColumn extends CustomTableColumn {
    constructor(name: string, label: string, path: string) {
        super(name, label, path);
    }
}
